import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const UserDetail = lazyLoader(
  () => import("Containers/User/UserDetail/UserDetail")
);

export const UserDetailsPage = () => {
  return (
    <Layout>
      <UserDetail />
    </Layout>
  );
};
